// Онбординг, экран 1 — «Как здесь учатся» (план §5.3).
//
// Пять открыток-слайдов заменены одним содержательным экраном: маршрут темы
// ①②③ и одна фраза о научной опоре. Экран ничего не спрашивает — это
// единственное место онбординга, которое объясняет.
//
// Контент — `MethodExplainer`, тот же компонент, что показывает справка «Как
// это работает». Своей копии текста ①②③ здесь нет и быть не может (инвариант
// PRODUCT-NARRATIVE §10.3): расхождение формулировок между онбордингом и
// справкой — гарантированный будущий дефект.

import { createFileRoute } from "@tanstack/react-router";
import { MethodExplainer } from "@/components/how-it-works/method-explainer";
import { OnboardingStepLayout } from "@/components/onboarding/onboarding-step-layout";
import { useOnboardingStep } from "@/components/onboarding/use-onboarding-step";

export const Route = createFileRoute("/onboarding/method")({
	component: MethodPage,
});

function MethodPage(): React.ReactElement {
	const step = useOnboardingStep("method");

	return (
		<OnboardingStepLayout stepNumber={step.stepNumber} onBack={step.goBack} onNext={step.goNext}>
			{/* Ссылки «Подробнее о методе» здесь НЕТ намеренно (решение владельца
			    2026-08-16): к этому экрану человек уже прошёл лендинг, где метод
			    разобран, и увод на публичную страницу посреди онбординга только
			    множит выходы. Разбор метода остаётся доступен с лендинга, из
			    справки «Как это работает» и по адресу `/method`. */}
			<MethodExplainer variant="roomy" />
		</OnboardingStepLayout>
	);
}
